import React, { useState } from 'react';
import { Button, Input, Form, Spin } from 'antd';
import axios from 'axios';
import { BASE_URL } from '../api';



const LoginPage = ({ onLogin }) => {

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // const onFinish = async (values) => {
  //   setLoading(true);
  //   setError('');
  //   try {
  //     const res = await axios.post(`${BASE_URL}/api/login`, values, { withCredentials: true });
  //     if (res.data && res.data.success) {
  //       onLogin(res.data.username);

  //     } else {
  //       setError(res.data.error || 'Login failed');
  //     }
  //   } catch (err) {
  //     setError('Login failed');
  //   } finally {
  //     setLoading(false);
  //   }
  // };


   const onFinish = async (values) => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post(`${BASE_URL}/api/login`, values, { withCredentials: true });
      if (res.data && res.data.success) {
        // CHANGED: Pass the entire user object to the onLogin handler
        onLogin(res.data.user); 
      } else {
        setError(res.data.error || 'Login failed');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f5f5f5' }}>
      <div style={{ background: 'white', padding: 32, borderRadius: 12, boxShadow: '0 2px 16px rgba(0,0,0,0.08)', minWidth: 340 }}>
        <h2 style={{ color: 'black', textAlign: 'center', marginBottom: 24 }}>Login</h2>
        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item name="username" label={<span style={{ color: 'black' }}>Username</span>} rules={[{ required: true, message: 'Please enter username' }]}> 
            <Input style={{ background: 'white', color: 'black' }} autoComplete="username" />
          </Form.Item>
          <Form.Item name="password" label={<span style={{ color: 'black' }}>Password</span>} rules={[{ required: true, message: 'Please enter password' }]}> 
            <Input.Password style={{ background: 'white', color: 'black' }} autoComplete="current-password" />
          </Form.Item>
          {error && <div style={{ color: 'red', marginBottom: 12 }}>{error}</div>}
          <Form.Item>
            <Button htmlType="submit" type="primary" style={{ background: 'black', color: 'white', width: '100%' }} loading={loading}>
              {loading ? <Spin size="small" /> : 'Login'}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default LoginPage;
